import { Component, Input, ViewChild, computed, effect, inject } from '@angular/core'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'
import { MobileTrackingService } from 'src/app/core/services/mobile-tracking.service'
import { MobileTracking } from 'src/app/shared/interfaces/mobile-tracking/mobile-tracking.interface'
import { GoogleMap, GoogleMapsModule, MapAdvancedMarker, MapInfoWindow } from '@angular/google-maps'
import { ButtonComponent } from '../../form-elements/button/button.component'
import { AppStore } from 'src/app/core/app.store'
import { toSignal } from '@angular/core/rxjs-interop'
import { BasicUser } from 'src/app/shared/interfaces/shared/basic-user.interface'
import { DatePipe } from '@angular/common'
import { EmptyComponent } from '../../empty/empty.component'
import { RouterLink } from '@angular/router'

@Component({
    selector: 'sf-staff-map-modal',
    imports: [RouterLink, MapAdvancedMarker, GoogleMapsModule, ButtonComponent, EmptyComponent],
    templateUrl: './staff-map-modal.component.html',
    styleUrls: ['./staff-map-modal.component.scss'],
    providers: [DatePipe],
})
export class StaffMapModalComponent {
    activeModal = inject(NgbActiveModal)

    #appStore = inject(AppStore)
    #datePipe = inject(DatePipe)
    #trackingService = inject(MobileTrackingService)

    staff = this.#appStore.staff()

    tracks: MobileTracking[] = []
    filteredTracks: MobileTracking[] = []

    @ViewChild(GoogleMap) map!: google.maps.Map
    @ViewChild(MapInfoWindow) infoWindow!: MapInfoWindow
    mapOptions: google.maps.MapOptions = {
        center: { lat: 51.5074, lng: 0.1278 },
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControl: true,
        styles: [
            {
                featureType: 'poi',
                elementType: 'labels',
                stylers: [{ visibility: 'off' }],
            },
        ],
    }

    bounds!: google.maps.LatLngBounds
    zoom = 10

    latestLocations = toSignal(this.#trackingService.getLatestStaffLocations(), { initialValue: [] })

    staffMarkers = computed(() => {
        const latest = this.latestLocations()

        this.bounds = new google.maps.LatLngBounds()

        return latest.map((x) => {
            this.bounds.extend({ lat: x.latitude, lng: x.longitude })

            return {
                position: { lat: x.latitude, lng: x.longitude },
                content: buildStaffMarkerContent(x.user),
                title: `${x.user.fullName} (last seen ${this.#datePipe.transform(x.created, 'dd/MM/yyyy HH:mma')})`,
            }
        }) as StaffMarker[]
    })

    staffMarkersEffect = effect(() => {
        const markers = this.staffMarkers()

        setTimeout(() => {
            this.map.fitBounds(this.bounds)
        }, 250)
    })
}

interface StaffMarker {
    position: google.maps.LatLngLiteral
    content: Node | google.maps.marker.PinElement
    title: string
}

function buildStaffMarkerContent(staff: BasicUser) {
    const content = document.createElement('div')
    content.classList.add('staff-marker')

    content.innerHTML = `
        <div class="staff-marker-container">
            <img 
                src="${staff.picture}" 
                alt="${staff.fullName}" 
                class="staff-marker-image" 
            />
            <div class="staff-marker-pulse"></div>
        </div>
    `

    return content
}
